import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

import SectionCard from '@/components/common/SectionCard/SectionCard';
import useGetContractDetails from '@/hooks/contract/useGetContractDetails.hook';
import ParentHeaders from './components/ParentHeaders/ParentHeaders';
import Toggle from '@/components/common/Toggle/Toggle';
import ToggleOptionTitle from '@/components/common/ToggleOption/ToggleOptionTitle';
import useToggleBillToParent from './hooks/useToggleBillToParent';

export default function ParentCompanyContainer() {
  const sectionCardRef = useRef<any>();
  const { contractId }: { contractId: UUID } = useParams();
  const { contract, isContractLoading } = useGetContractDetails(contractId);
  const [enabled, setEnabled] = useState(Boolean(contract?.billToParent));
  const billToParentVisible = contract?.customer?.parentCustomer?.customerID;
  const { toggleBillToParent } = useToggleBillToParent(contractId);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onChange = async () => {
    setEnabled(!enabled);
    const toggledResult = await toggleBillToParent(!enabled);

    if (!toggledResult)
      return setEnabled(false);
  };

  useEffect(() => {
    if (contract?.billToParent) {
      setEnabled(Boolean(contract?.billToParent));
    }

  }, [contract?.billToParent]);


  return (
    <div className="mb-20">
      <SectionCard
        ref={sectionCardRef}
        title={{
          titleText: 'Billing Information',
        }}
        padding={true}
      >
        <ParentHeaders
          isLoadingContractDetails={isContractLoading}
          contract={contract}
        />
        {billToParentVisible && (<div style={{ marginTop: '10px' }}>
          <div style={{ marginBottom: '5px' }}>
            <ToggleOptionTitle>Bill To Parent</ToggleOptionTitle>

          </div>
          <Toggle
            id={'123456'}
            isEnable={enabled}
            onChange={() => { }}
          />
        </div>)}
      </SectionCard>
    </div>
  );
}
